<template>
    <section>
        <VideoPoup :videoData="videoData" />
        <div class="row">
            <div class="col-sm-3 cus-sidebar">
                <Sidebar />
            </div>
            <div v-if="isLoading" class="loader">
                <div class="wave-container">
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                </div>
                <p>Loading...</p>
            </div>
            <div v-if="!isLoading" class="col-sm-9 right-colm">
                <div class="material-box bg-white p-2">
                    <div class="row content-row ">
                        <div class="col-md-12 top-title">
                            <h3>Seminar Archives - Module {{ weeks[0].ModuleNumber }} - {{ weeks[0].ModuleName }}</h3>
                        </div>
                        <div class="col-md-12 ">
                            <div class="content-colm row">
                                <div class="col-md-12">
                                    <span class="df-font"> Seminars, which were conducted for Module {{
                                        weeks[0].ModuleNumber }}, {{  getYear(weeks[0].ModuleStartDate) }}.</span>
                                    <hr style="height:1px;">
                                    <br>
                                </div>

                                <div class="col-md-12">
                                    <div class="material-list video">
                                        <div class="row">

                                            <div class="col-md-6">
                                                <ul>
                                                    <span v-for="(week, index) in weeks" :key="index">
                                                        <li v-if="index < 5">
                                                            <a  style="color: #878888; text-decoration: none;" @click.prevent="videoModelShow(week.SeminarVimeoLink)" href="#"> Week
                                                                {{ week.WeekNumber }} - {{ week.WeekName }}</a>
                                                        </li>
                                                    </span>
                                                </ul>
                                            </div>

                                            <div class="col-md-6">
                                                <ul>
                                                    <span v-for="(week, index) in weeks" :key="index">
                                                        <li v-if="index >= 5">

                                                            <a style="color: #878888; text-decoration: none;" @click.prevent="videoModelShow(week.SeminarVimeoLink)" href="#"> Week
                                                                {{ week.WeekNumber }} - {{ week.WeekName }}</a>
                                                        </li>
                                                    </span>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Sidebar from './components/Sidebar.vue';
import userAPI from '../userApi';
import moment from 'moment';
import VideoPoup from './components/VideoPoup.vue';
// import ModuleBox from './components/ModuleBox.vue';

export default {
    name: "SeminarArchive",
    data() {
        return {
            isLoading: false,
            id: "",
            moduleData: {},
            weeksWithVideosDocuments: {},
            videoData:{
                videoSrc:""
            },
            weeks: {}
        }
    },
    methods: {
        videoModelShow(src) {
            this.videoData.videoSrc = 'https://player.vimeo.com/video/' + src;
            this.$bvModal.show('videoModel');
        },
        getYear(date) {
            let nowDate = new Date(moment().format('MM-DD-Y'));
            let mDate = new Date(moment(date).format('MM-DD-Y'));
            let year = moment(date).format("Y");
            if (nowDate > mDate) {
                return year;
            } else {
                return year;
            }
        },
        getSeminarScheduleByModuleID() {
            this.isLoading = true;
            userAPI.getSeminarScheduleByModuleID({ moduleID: this.id }, res => {
                this.weeks = res.data.data;
                this.isLoading = false;

            }, err => {
                console.log(err);
                this.isLoading = false;

            })
        }
    },
    mounted() {

        if (this.$route.params.id != undefined || this.$route.params.id != null) {
            this.id = this.$route.params.id;
        } else {
            this.$router.push({ name: 'user_seminar' });
        }
        this.getSeminarScheduleByModuleID()
    },
    components: {
        Sidebar,
        VideoPoup
    }
}
</script>